"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Revieve = require("./Revieve");
Object.keys(_Revieve).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Revieve[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Revieve[key];
    }
  });
});
var _TranslationKey = require("./TranslationKey");
Object.keys(_TranslationKey).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TranslationKey[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TranslationKey[key];
    }
  });
});